import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import FullPageScroll from './FullPageScroll'

gsap.registerPlugin(ScrollTrigger)
export default class StoryText
{
  constructor()
  {
    this.fullPageScroll = new FullPageScroll()
    this.scroller = this.fullPageScroll.scroller

    this.animationSpeed = 0.1
    this.circleOpacity = 0.6
    this.scrubStrength = 1
    this.yearOpacity = 0
    this.circleMoveSpeed = 1.3
    this.circleFadeInSpeed = 0.8
    this.circleFadeOutSpeed = 1.5

    this.setScrollTriggerToTop(this.scroller)
    this.setScrollTriggerToYear1950(this.scroller)
    this.setScrollTriggerToYear2020(this.scroller)
    this.setScrollTriggerToYearCurrent(this.scroller)
    this.setScrollTriggerToBottomMessage(this.scroller)
  }

  setScrollTriggerToTop(scroller)
  {
    gsap.fromTo(".story_mv", {opacity: 0, y: 35}, {opacity: 1, y: 0, duration: 2, ease: 'Power2.easeOut'})

    const messageTl = gsap.timeline(
      {
        scrollTrigger:
        {
          trigger: ".story_intro",
          scroller: scroller,
          start: "top center+=35%",
          end: "bottom top",
          toggleActions: "play none none none",
        }
      }
    )
    
    ScrollTrigger.create({
      trigger: ".story_intro",
      scroller: scroller,
      start: "top top",
      end: "+=50%",
      pin: false
    })

    messageTl
    .fromTo(".titleFadeIn", {opacity: 0, y: 30},  {opacity: 1, y: 0, duration: 1.0, ease: 'Power1.easeOut' }, 0)
    .fromTo(".messageFadeIn", {opacity: 0, y: 30},  {opacity: 1, y: 0, duration: 1.0, ease: 'Power3.easeOut' }, 0.7)
  }

  setScrollTriggerToYear1950(scroller)
  {
    const speed = this.animationSpeed
    // セクションのメインアニメーション
    const titleElement = document.querySelector('._head_title1950')
    const circleElement1 = document.querySelector('.story_circle1950_1')
    const circleElement2 = document.querySelector('.story_circle1950_2')
    const circleElement3 = document.querySelector('.story_circle1950_3')
    const textTitle = document.querySelector('._textTitle1950')
    const textParagraph = document.querySelector('._text1950')

    const _1950Tl = gsap.timeline(
      {
        scrollTrigger:
        {
          trigger: "._year1950Main",
          scroller: scroller,
          start: "top center+=25%",
          end: "bottom top",
          toggleActions: "play none none none",
        }
      }
    )

    // ScrollTrigger.create({
    //   trigger: "._year1950Main",
    //   scroller: scroller,
    //   start: "top top",
    //   end: "+=80%",
    //   pin: false,
    // })

    // responsive 480
    if(window.innerWidth > 1300){
      _1950Tl
      // 年代フェードイン
      .from(titleElement, { duration: 1, autoAlpha: 0, y: 30, ease: 'Power3.easeOut' }, 0)
      // 年代フェードアウト
      // .to(titleElement, { duration: 2, autoAlpha: this.yearOpacity, ease: 'Power1.easeOut' }, 2.5 * speed)
      // // 年代小フェードイン
      // .from('._subYear1950', { duration: 1.5, autoAlpha: 0, ease: 'Power3.easeOut'}, 5.6 * speed)
      // 円シェイプのフェードイン
      .from(circleElement1, { duration: this.circleFadeInSpeed, autoAlpha: 0, ease: 'Power3.easeOut' }, 4 * speed)
      .from(circleElement2, { duration: this.circleFadeInSpeed, autoAlpha: 0, ease: 'Power3.easeOut' }, 4 * speed)
      .from(circleElement3, { duration: this.circleFadeInSpeed, autoAlpha: 0, ease: 'Power3.easeOut' }, 4 * speed)
      // 円シェイプが動く
      .to(circleElement1, { duration: this.circleMoveSpeed, xPercent: -152, yPercent: 100, ease: 'Power2.easeOut' }, 9 * speed)
      .to(circleElement2, { duration: this.circleMoveSpeed, xPercent: -250, yPercent: 41, ease: 'Power2.easeOut' }, 9 * speed)
      .to(circleElement3, { duration: this.circleMoveSpeed, xPercent: 180, yPercent: 41, ease: 'Power2.easeOut' }, 9 * speed)
      // テキストタイトルのフェードイン
      .from(textTitle, { duration: 1.2, autoAlpha: 0, y: 30, ease: 'Power1.easeOut' }, 0.7)
      // テキスト本文のフェードイン
      .from(textParagraph, { duration: 1.5, autoAlpha: 0, y: 30, ease: 'Power3.easeOut'}, 0.9)
      // 円シェイプのフェードアウト
      .to(circleElement1, { duration: this.circleFadeOutSpeed, autoAlpha: this.circleOpacity, ease: 'Power3.easeOut' }, 12 * speed)
      .to(circleElement2, { duration: this.circleFadeOutSpeed, autoAlpha: this.circleOpacity, ease: 'Power3.easeOut' }, 12 * speed)
      .to(circleElement3, { duration: this.circleFadeOutSpeed, autoAlpha: this.circleOpacity, ease: 'Power3.easeOut' }, 12 * speed)
    } else if(window.innerWidth > 960){
      _1950Tl
      // 年代フェードイン
      .from(titleElement, { duration: 1, autoAlpha: 0, y: 30, ease: 'Power3.easeOut' }, 0)
      // 年代フェードアウト
      // .to(titleElement, { duration: 2, autoAlpha: this.yearOpacity, ease: 'Power1.easeOut' }, 2.5 * speed)
      // // 年代小フェードイン
      // .from('._subYear1950', { duration: 1.5, autoAlpha: 0, ease: 'Power3.easeOut'}, 5.6 * speed)
      // 円シェイプのフェードイン
      .from(circleElement1, { duration: this.circleFadeInSpeed, autoAlpha: 0, ease: 'Power3.easeOut' }, 4 * speed)
      .from(circleElement2, { duration: this.circleFadeInSpeed, autoAlpha: 0, ease: 'Power3.easeOut' }, 4 * speed)
      .from(circleElement3, { duration: this.circleFadeInSpeed, autoAlpha: 0, ease: 'Power3.easeOut' }, 4 * speed)
      // 円シェイプが動く
      .to(circleElement1, { duration: this.circleMoveSpeed, xPercent: -152 / 1.3, yPercent: 100, ease: 'Power2.easeOut' }, 9 * speed)
      .to(circleElement2, { duration: this.circleMoveSpeed, xPercent: -250 / 1.3, yPercent: 41, ease: 'Power2.easeOut' }, 9 * speed)
      .to(circleElement3, { duration: this.circleMoveSpeed, xPercent: 180 / 1.3, yPercent: 41, ease: 'Power2.easeOut' }, 9 * speed)
      // テキストタイトルのフェードイン
      .from(textTitle, { duration: 1.2, autoAlpha: 0, y: 30, ease: 'Power1.easeOut' }, 0.7)
      // テキスト本文のフェードイン
      .from(textParagraph, { duration: 1.5, autoAlpha: 0, y: 30, ease: 'Power3.easeOut'}, 0.9)
      // 円シェイプのフェードアウト
      .to(circleElement1, { duration: this.circleFadeOutSpeed, autoAlpha: this.circleOpacity, ease: 'Power3.easeOut' }, 12 * speed)
      .to(circleElement2, { duration: this.circleFadeOutSpeed, autoAlpha: this.circleOpacity, ease: 'Power3.easeOut' }, 12 * speed)
      .to(circleElement3, { duration: this.circleFadeOutSpeed, autoAlpha: this.circleOpacity, ease: 'Power3.easeOut' }, 12 * speed)
    } else if(window.innerWidth > 481)
    {
      _1950Tl
      // 年代フェードイン
      .from(titleElement, { duration: 1, autoAlpha: 0, y: 30, ease: 'Power3.easeOut' }, 0)
      // 年代フェードアウト
      // .to(titleElement, { duration: 2, autoAlpha: this.yearOpacity, ease: 'Power1.easeOut' }, 2.5 * speed)
      // // 年代小フェードイン
      // .from('._subYear1950', { duration: 1.5, autoAlpha: 0, ease: 'Power3.easeOut'}, 5.6 * speed)
      // 円シェイプのフェードイン
      .from(circleElement1, { duration: this.circleFadeInSpeed, autoAlpha: 0, ease: 'Power3.easeOut' }, 4 * speed)
      .from(circleElement2, { duration: this.circleFadeInSpeed, autoAlpha: 0, ease: 'Power3.easeOut' }, 4 * speed)
      .from(circleElement3, { duration: this.circleFadeInSpeed, autoAlpha: 0, ease: 'Power3.easeOut' }, 4 * speed)
      // 円シェイプが動く
      .to(circleElement1, { duration: this.circleMoveSpeed, xPercent: -152 / 1.8, yPercent: 10, ease: 'Power2.easeOut' }, 9 * speed)
      .to(circleElement2, { duration: this.circleMoveSpeed, xPercent: -250 / 2, yPercent: 41, ease: 'Power2.easeOut' }, 9 * speed)
      .to(circleElement3, { duration: this.circleMoveSpeed, xPercent: 180 / 1.7, yPercent: 10, ease: 'Power2.easeOut' }, 9 * speed)
      // テキストタイトルのフェードイン
      .from(textTitle, { duration: 1.2, autoAlpha: 0, y: 30, ease: 'Power1.easeOut' }, 0.7)
      // テキスト本文のフェードイン
      .from(textParagraph, { duration: 1.5, autoAlpha: 0, y: 30, ease: 'Power3.easeOut'}, 0.9)
      // 円シェイプのフェードアウト
      .to(circleElement1, { duration: this.circleFadeOutSpeed, autoAlpha: this.circleOpacity, ease: 'Power3.easeOut' }, 12 * speed)
      .to(circleElement2, { duration: this.circleFadeOutSpeed, autoAlpha: this.circleOpacity, ease: 'Power3.easeOut' }, 12 * speed)
      .to(circleElement3, { duration: this.circleFadeOutSpeed, autoAlpha: this.circleOpacity, ease: 'Power3.easeOut' }, 12 * speed)

    } else
    {
      _1950Tl
      // 年代フェードイン
      .from(titleElement, { duration: 1, autoAlpha: 0, y: 30, ease: 'Power3.easeOut' }, 0)
      // 年代フェードアウト
      // .to(titleElement, { duration: 2, autoAlpha: this.yearOpacity, ease: 'Power1.easeOut'}, 2.5 * speed)
      // 年代小フェードイン
      // .from('._subYear1950', { duration: 1.5, autoAlpha: 0, ease: 'Power3.easeOut'}, 5.6 * speed)
      // 円シェイプのフェードイン
      .from(circleElement1, { duration: this.circleFadeInSpeed, autoAlpha: 0, ease: 'Power3.easeOut' }, 4 * speed)
      .from(circleElement2, { duration: this.circleFadeInSpeed, autoAlpha: 0, ease: 'Power3.easeOut' }, 4 * speed)
      .from(circleElement3, { duration: this.circleFadeInSpeed, autoAlpha: 0, ease: 'Power3.easeOut' }, 4 * speed)
      // 円シェイプが動く
      .to(circleElement1, { duration: this.circleMoveSpeed / 1.5, xPercent: -120 / 8, yPercent: -62 / 4 *  1, ease: 'Power2.easeOut' }, 9 * speed + 0.3)
      .to(circleElement2, { duration: this.circleMoveSpeed / 1.5, xPercent: -211 / 32, yPercent: -89 / 8 * 1.2, ease: 'Power2.easeOut' }, 9 * speed + 0.3)
      .to(circleElement3, { duration: this.circleMoveSpeed / 1.5, xPercent: 144 / 16, yPercent: 16 / 4 * - 4.5, ease: 'Power2.easeOut' }, 9 * speed + 0.3)
      // テキストタイトルのフェードイン
      .from(textTitle, { duration: 1.2, autoAlpha: 0, y: 30, ease: 'Power1.easeOut' }, 0.7)
      // テキスト本文のフェードイン
      .from(textParagraph, { duration: 1.5, autoAlpha: 0, y: 30, ease: 'Power3.easeOut'}, 0.9)
      // 円シェイプのフェードアウト
      .to(circleElement1, { duration: this.circleFadeOutSpeed * 1.5, autoAlpha: this.circleOpacity / 2, ease: 'Power2.easeOut' }, 12 * speed + 0.2)
      .to(circleElement2, { duration: this.circleFadeOutSpeed * 1.5, autoAlpha: this.circleOpacity / 2, ease: 'Power2.easeOut' }, 12 * speed + 0.2)
      .to(circleElement3, { duration: this.circleFadeOutSpeed * 1.5, autoAlpha: this.circleOpacity / 2, ease: 'Power2.easeOut' }, 12 * speed + 0.2)
    }


    // GSDevTools.create({animation: _1950Tl})

    // 図のアニメーション
    const _1950Tl2 = gsap.timeline(
      {
        // defaults: {ease: "expo.inOut"},
        scrollTrigger:
        {
          trigger: "._year1950Second",
          scroller: scroller,
          start: "top center+=15%",
          end: "bottom bottom",
          toggleActions: "play none none none",
        }
      }
    )

    // ScrollTrigger.create({
    //   trigger: "._year1950Second",
    //   scroller: scroller,
    //   start: "top top",
    //   end: "+=80%",
    //   pin: false
    // })

    _1950Tl2
    .from('._year1950SecondAnimation', { duration: 1.2, autoAlpha: 0, ease: 'Power1.easeOut' })
  }


  setScrollTriggerToYear2020(scroller)
  {
    const speed = this.animationSpeed
    // セクションのメインアニメーション
    const titleElement = document.querySelector('._head_title2020')
    const circleElement1 = document.querySelector('.story_circle2020_1')
    const circleElement2 = document.querySelector('.story_circle2020_2')
    const circleElement3 = document.querySelector('.story_circle2020_3')
    const textTitle = document.querySelector('._textTitle2020')
    const textParagraph = document.querySelector('._text2020')

    const _2020Tl = gsap.timeline(
      {
        scrollTrigger:
        {
          trigger: "._year2020Main",
          scroller: scroller,
          start: "top center+=20%",
          end: "bottom top",
          toggleActions: "play none none none",
        }
      }
    )

    // ScrollTrigger.create({
    //   trigger: "._year2020Main",
    //   scroller: scroller,
    //   start: "top top",
    //   end: "+=80%",
    //   pin: false
    // })

    // responsive 480
    if(window.innerWidth > 1300)
    {
      _2020Tl
      // 年代フェードイン
      .from(titleElement, { duration: 1, autoAlpha: 0, y: 30, ease: 'Power3.easeOut' }, 0)
      // 年代フェードアウト
      // .to(titleElement, { duration: 2, autoAlpha: this.yearOpacity, ease: 'Power1.easeOut'}, 2.5 * speed)
      // 年代小フェードイン
      // .from('._subYear2020', { duration: 1.5, autoAlpha: 0, ease: 'Power3.easeOut'}, 5.6 * speed)
      // 円シェイプのフェードイン
      .from(circleElement1, { duration: this.circleFadeInSpeed, autoAlpha: 0, ease: 'Power3.easeOut' }, 4 * speed)
      .from(circleElement2, { duration: this.circleFadeInSpeed, autoAlpha: 0, ease: 'Power3.easeOut' }, 4 * speed)
      .from(circleElement3, { duration: this.circleFadeInSpeed, autoAlpha: 0, ease: 'Power3.easeOut' }, 4 * speed)
      // 円シェイプが動く
      .to(circleElement1, { duration: this.circleMoveSpeed, xPercent: -148, yPercent: 35, ease: 'Power2.easeOut' }, 9 * speed)
      .to(circleElement2, { duration: this.circleMoveSpeed, xPercent: 168, yPercent: 5, ease: 'Power2.easeOut' }, 9 * speed)
      .to(circleElement3, { duration: this.circleMoveSpeed, xPercent: 112, yPercent: 92, ease: 'Power2.easeOut' }, 9 * speed)
      // テキストタイトルのフェードイン
      .from(textTitle, { duration: 1.2, autoAlpha: 0, y: 30, ease: 'Power1.easeOut' }, 0.7)
      // テキスト本文のフェードイン
      .from(textParagraph, { duration: 1.5, autoAlpha: 0, y: 30, ease: 'Power3.easeOut'}, 0.9)
      // 円シェイプのフェードアウト
      .to(circleElement1, { duration: this.circleFadeOutSpeed, autoAlpha: this.circleOpacity, ease: 'Power3.easeOut' }, 12 * speed)
      .to(circleElement2, { duration: this.circleFadeOutSpeed, autoAlpha: this.circleOpacity, ease: 'Power3.easeOut' }, 12 * speed)
      .to(circleElement3, { duration: this.circleFadeOutSpeed, autoAlpha: this.circleOpacity, ease: 'Power3.easeOut' }, 12 * speed)
    } else if(window.innerWidth > 960)
    {
      _2020Tl
      // 年代フェードイン
      .from(titleElement, { duration: 1, autoAlpha: 0, y: 30, ease: 'Power3.easeOut' }, 0)
      // 年代フェードアウト
      // .to(titleElement, { duration: 2, autoAlpha: this.yearOpacity, ease: 'Power1.easeOut'}, 2.5 * speed)
      // 年代小フェードイン
      // .from('._subYear2020', { duration: 1.5, autoAlpha: 0, ease: 'Power3.easeOut'}, 5.6 * speed)
      // 円シェイプのフェードイン
      .from(circleElement1, { duration: this.circleFadeInSpeed, autoAlpha: 0, ease: 'Power3.easeOut' }, 4 * speed)
      .from(circleElement2, { duration: this.circleFadeInSpeed, autoAlpha: 0, ease: 'Power3.easeOut' }, 4 * speed)
      .from(circleElement3, { duration: this.circleFadeInSpeed, autoAlpha: 0, ease: 'Power3.easeOut' }, 4 * speed)
      // 円シェイプが動く
      .to(circleElement1, { duration: this.circleMoveSpeed, xPercent: -148 / 1.3, yPercent: 35, ease: 'Power2.easeOut' }, 9 * speed)
      .to(circleElement2, { duration: this.circleMoveSpeed, xPercent: 168 / 1.3, yPercent: 5, ease: 'Power2.easeOut' }, 9 * speed)
      .to(circleElement3, { duration: this.circleMoveSpeed, xPercent: 112 / 1.3, yPercent: 92, ease: 'Power2.easeOut' }, 9 * speed)
      // テキストタイトルのフェードイン
      .from(textTitle, { duration: 1.2, autoAlpha: 0, y: 30, ease: 'Power1.easeOut' }, 0.7)
      // テキスト本文のフェードイン
      .from(textParagraph, { duration: 1.5, autoAlpha: 0, y: 30, ease: 'Power3.easeOut'}, 0.9)
      // 円シェイプのフェードアウト
      .to(circleElement1, { duration: this.circleFadeOutSpeed, autoAlpha: this.circleOpacity, ease: 'Power3.easeOut' }, 12 * speed)
      .to(circleElement2, { duration: this.circleFadeOutSpeed, autoAlpha: this.circleOpacity, ease: 'Power3.easeOut' }, 12 * speed)
      .to(circleElement3, { duration: this.circleFadeOutSpeed, autoAlpha: this.circleOpacity, ease: 'Power3.easeOut' }, 12 * speed)
    }else if(window.innerWidth > 481) {
      _2020Tl
      // 年代フェードイン
      .from(titleElement, { duration: 1, autoAlpha: 0, y: 30, ease: 'Power3.easeOut' }, 0)
      // 年代フェードアウト
      // .to(titleElement, { duration: 2, autoAlpha: this.yearOpacity, ease: 'Power1.easeOut'}, 2.5 * speed)
      // 年代小フェードイン
      // .from('._subYear2020', { duration: 1.5, autoAlpha: 0, ease: 'Power3.easeOut'}, 5.6 * speed)
      // 円シェイプのフェードイン
      .from(circleElement1, { duration: this.circleFadeInSpeed, autoAlpha: 0, ease: 'Power3.easeOut' }, 4 * speed)
      .from(circleElement2, { duration: this.circleFadeInSpeed, autoAlpha: 0, ease: 'Power3.easeOut' }, 4 * speed)
      .from(circleElement3, { duration: this.circleFadeInSpeed, autoAlpha: 0, ease: 'Power3.easeOut' }, 4 * speed)
      // 円シェイプが動く
      .to(circleElement1, { duration: this.circleMoveSpeed, xPercent: -148 / 1.5, yPercent: 35, ease: 'Power2.easeOut' }, 9 * speed)
      .to(circleElement2, { duration: this.circleMoveSpeed, xPercent: 168 / 1.5, yPercent: 5, ease: 'Power2.easeOut' }, 9 * speed)
      .to(circleElement3, { duration: this.circleMoveSpeed, xPercent: 112 / 1.2, yPercent: 92, ease: 'Power2.easeOut' }, 9 * speed)
      // テキストタイトルのフェードイン
      .from(textTitle, { duration: 1.2, autoAlpha: 0, y: 30, ease: 'Power1.easeOut' }, 0.7)
      // テキスト本文のフェードイン
      .from(textParagraph, { duration: 1.5, autoAlpha: 0, y: 30, ease: 'Power3.easeOut'}, 0.9)
      // 円シェイプのフェードアウト
      .to(circleElement1, { duration: this.circleFadeOutSpeed, autoAlpha: this.circleOpacity, ease: 'Power3.easeOut' }, 12 * speed)
      .to(circleElement2, { duration: this.circleFadeOutSpeed, autoAlpha: this.circleOpacity, ease: 'Power3.easeOut' }, 12 * speed)
      .to(circleElement3, { duration: this.circleFadeOutSpeed, autoAlpha: this.circleOpacity, ease: 'Power3.easeOut' }, 12 * speed)
    } else 
    {
      _2020Tl
      // 年代フェードイン
      .from(titleElement, { duration: 1, autoAlpha: 0, y: 30, ease: 'Power3.easeOut' }, 0)
      // 年代フェードアウト
      // .to(titleElement, { duration: 2, autoAlpha: this.yearOpacity, ease: 'Power1.easeOut'}, 2.5 * speed)
      // 年代小フェードイン
      // .from('._subYear2020', { duration: 1.5, autoAlpha: 0, ease: 'Power3.easeOut'}, 5.6 * speed)
      // 円シェイプのフェードイン
      .from(circleElement1, { duration: this.circleFadeInSpeed, autoAlpha: 0, ease: 'Power3.easeOut' }, 4 * speed)
      .from(circleElement2, { duration: this.circleFadeInSpeed, autoAlpha: 0, ease: 'Power3.easeOut' }, 4 * speed)
      .from(circleElement3, { duration: this.circleFadeInSpeed, autoAlpha: 0, ease: 'Power3.easeOut' }, 4 * speed)
      // 円シェイプが動く
      .to(circleElement1, { duration: this.circleMoveSpeed / 1.5, xPercent: -120 / 8, yPercent: -62/ 4 * 1, ease: 'Power2.easeOut' }, 9 * speed + 0.3)
      .to(circleElement2, { duration: this.circleMoveSpeed / 1.5, xPercent: 211 / 8, yPercent: -89 / 8 * 1.2, ease: 'Power2.easeOut' }, 9 * speed + 0.3)
      .to(circleElement3, { duration: this.circleMoveSpeed / 1.5, xPercent: 144 / 16, yPercent: 16 / 10 * - 4.5, ease: 'Power2.easeOut' }, 9 * speed + 0.3)
      // テキストタイトルのフェードイン
      .from(textTitle, { duration: 1.2, autoAlpha: 0, y: 30, ease: 'Power1.easeOut' }, 0.7)
      // テキスト本文のフェードイン
      .from(textParagraph, { duration: 1.5, autoAlpha: 0, y: 30, ease: 'Power3.easeOut'}, 0.9)
      // 円シェイプのフェードアウト
      .to(circleElement1, { duration: this.circleFadeOutSpeed * 1.5, autoAlpha: this.circleOpacity / 2, ease: 'Power2.easeOut' }, 12 * speed + 0.2)
      .to(circleElement2, { duration: this.circleFadeOutSpeed * 1.5, autoAlpha: this.circleOpacity / 2, ease: 'Power2.easeOut' }, 12 * speed + 0.2)
      .to(circleElement3, { duration: this.circleFadeOutSpeed * 1.5, autoAlpha: this.circleOpacity / 2, ease: 'Power2.easeOut' }, 12 * speed + 0.2)
    }
  }

  setScrollTriggerToYearCurrent(scroller)
  {
    const speed = this.animationSpeed
    // セクションのメインアニメーション
    const titleElement = document.querySelector('._head_titleCurrent')
    const circleElement1 = document.querySelector('.story_circleCurrent_1')
    const circleElement2 = document.querySelector('.story_circleCurrent_2')
    const circleElement3 = document.querySelector('.story_circleCurrent_3')
    const textTitle = document.querySelector('._textTitleCurrent')
    const textParagraph = document.querySelector('._textCurrent')
    const overlay = document.querySelector('._overlay')

    const _CurrentTl = gsap.timeline(
      {
        scrollTrigger:
        {
          trigger: "._yearCurrentMain",
          scroller: scroller,
          start: "top center+=20%",
          end: "bottom top",
          toggleActions: "play none none none",
        }
      }
    )

    // ScrollTrigger.create({
    //   trigger: "._yearCurrentMain",
    //   scroller: scroller,
    //   start: "top top",
    //   end: "+=80%",
    //   pin: false
    // })

    // responsive 480
    if(window.innerWidth > 1300)
    {
      _CurrentTl
      .to(overlay, {duration: 5, opacity: 0.3, ease: 'Power3.easeOut'}, 0)
      // 年代フェードイン
      .from(titleElement, { duration: 1, autoAlpha: 0, y: 30, ease: 'Power3.easeOut' }, 0)
      // 年代フェードアウト
      // .to(titleElement, { duration: 2, autoAlpha: this.yearOpacity, ease: 'Power1.easeOut' }, 2.5 * speed)
      // 年代小フェードイン
      // .from('._subYearCurrent', { duration: 1.5, autoAlpha: 0, ease: 'Power3.easeOut'}, 5.6 * speed)
      // 円シェイプのフェードイン
      .from(circleElement1, { duration: this.circleFadeInSpeed, autoAlpha: 0, ease: 'Power3.easeOut' }, 4 * speed)
      .from(circleElement2, { duration: this.circleFadeInSpeed, autoAlpha: 0, ease: 'Power3.easeOut' }, 4 * speed)
      .from(circleElement3, { duration: this.circleFadeInSpeed, autoAlpha: 0, ease: 'Power3.easeOut' }, 4 * speed)
      // 円シェイプが動く
      .to(circleElement1, { duration: this.circleMoveSpeed, xPercent: -95, yPercent: 62, ease: 'Power2.easeOut' }, 9 * speed)
      .to(circleElement2, { duration: this.circleMoveSpeed, xPercent: -145, yPercent: 80, ease: 'Power2.easeOut' }, 9 * speed)
      .to(circleElement3, { duration: this.circleMoveSpeed, xPercent: 88, yPercent: 105, ease: 'Power2.easeOut' }, 9 * speed)
      // テキストタイトルのフェードイン
      .from(textTitle, { duration: 1.2, autoAlpha: 0, y: 30, ease: 'Power1.easeOut' }, 0.7)
      // テキスト本文のフェードイン
      .from(textParagraph, { duration: 1.5, autoAlpha: 0, y: 30, ease: 'Power3.easeOut' }, 0.9)
      // // ２枚の画像のフェードイン
      // .from('._yearCurrentSecondAnimationImage', { duration: 8, autoAlpha: 0, y: 30 }, 9 * speed)
      // 円シェイプのフェードアウト
      .to(circleElement1, { duration: this.circleFadeOutSpeed, autoAlpha: this.circleOpacity, ease: 'Power3.easeOut' }, 12 * speed)
      .to(circleElement2, { duration: this.circleFadeOutSpeed, autoAlpha: this.circleOpacity, ease: 'Power3.easeOut' }, 12 * speed)
      .to(circleElement3, { duration: this.circleFadeOutSpeed, autoAlpha: this.circleOpacity, ease: 'Power3.easeOut' }, 12 * speed)
    } else if(window.innerWidth > 960)
    {
      _CurrentTl
      .to(overlay, {duration: 5, opacity: 0.3, ease: 'Power3.easeOut'}, 0)
      // 年代フェードイン
      .from(titleElement, { duration: 1, autoAlpha: 0, y: 30, ease: 'Power3.easeOut' }, 0)
      // 年代フェードアウト
      // .to(titleElement, { duration: 2, autoAlpha: this.yearOpacity, ease: 'Power1.easeOut' }, 2.5 * speed)
      // 年代小フェードイン
      // .from('._subYearCurrent', { duration: 1.5, autoAlpha: 0, ease: 'Power3.easeOut'}, 5.6 * speed)
      // 円シェイプのフェードイン
      .from(circleElement1, { duration: this.circleFadeInSpeed, autoAlpha: 0, ease: 'Power3.easeOut' }, 4 * speed)
      .from(circleElement2, { duration: this.circleFadeInSpeed, autoAlpha: 0, ease: 'Power3.easeOut' }, 4 * speed)
      .from(circleElement3, { duration: this.circleFadeInSpeed, autoAlpha: 0, ease: 'Power3.easeOut' }, 4 * speed)
      // 円シェイプが動く
      .to(circleElement1, { duration: this.circleMoveSpeed, xPercent: -95 / 1.3, yPercent: 62, ease: 'Power2.easeOut' }, 9 * speed)
      .to(circleElement2, { duration: this.circleMoveSpeed, xPercent: -145 / 1.3, yPercent: 80, ease: 'Power2.easeOut' }, 9 * speed)
      .to(circleElement3, { duration: this.circleMoveSpeed, xPercent: 88 / 1.3, yPercent: 105, ease: 'Power2.easeOut' }, 9 * speed)
      // テキストタイトルのフェードイン
      .from(textTitle, { duration: 1.2, autoAlpha: 0, y: 30, ease: 'Power1.easeOut' }, 0.7)
      // テキスト本文のフェードイン
      .from(textParagraph, { duration: 1.5, autoAlpha: 0, y: 30, ease: 'Power3.easeOut' }, 0.9)
      // // ２枚の画像のフェードイン
      // .from('._yearCurrentSecondAnimationImage', { duration: 8, autoAlpha: 0, y: 30 }, 9 * speed)
      // 円シェイプのフェードアウト
      .to(circleElement1, { duration: this.circleFadeOutSpeed, autoAlpha: this.circleOpacity, ease: 'Power3.easeOut' }, 12 * speed)
      .to(circleElement2, { duration: this.circleFadeOutSpeed, autoAlpha: this.circleOpacity, ease: 'Power3.easeOut' }, 12 * speed)
      .to(circleElement3, { duration: this.circleFadeOutSpeed, autoAlpha: this.circleOpacity, ease: 'Power3.easeOut' }, 12 * speed)
    } 
    else if(window.innerWidth > 481) {
      _CurrentTl
      .to(overlay, {duration: 5, opacity: 0.3, ease: 'Power3.easeOut'}, 0)
      // 年代フェードイン
      .from(titleElement, { duration: 1, autoAlpha: 0, y: 30, ease: 'Power3.easeOut' }, 0)
      // 年代フェードアウト
      // .to(titleElement, { duration: 2, autoAlpha: this.yearOpacity, ease: 'Power1.easeOut' }, 2.5 * speed)
      // 年代小フェードイン
      // .from('._subYearCurrent', { duration: 1.5, autoAlpha: 0, ease: 'Power3.easeOut'}, 5.6 * speed)
      // 円シェイプのフェードイン
      .from(circleElement1, { duration: this.circleFadeInSpeed, autoAlpha: 0, ease: 'Power3.easeOut' }, 4 * speed)
      .from(circleElement2, { duration: this.circleFadeInSpeed, autoAlpha: 0, ease: 'Power3.easeOut' }, 4 * speed)
      .from(circleElement3, { duration: this.circleFadeInSpeed, autoAlpha: 0, ease: 'Power3.easeOut' }, 4 * speed)
      // 円シェイプが動く
      .to(circleElement1, { duration: this.circleMoveSpeed, xPercent: -95 / 1.5, yPercent: 52, ease: 'Power2.easeOut' }, 9 * speed)
      .to(circleElement2, { duration: this.circleMoveSpeed, xPercent: -145 / 1.5, yPercent: 80, ease: 'Power2.easeOut' }, 9 * speed)
      .to(circleElement3, { duration: this.circleMoveSpeed, xPercent: 88 / 1.5, yPercent: 105, ease: 'Power2.easeOut' }, 9 * speed)
      // テキストタイトルのフェードイン
      .from(textTitle, { duration: 1.2, autoAlpha: 0, y: 30, ease: 'Power1.easeOut' }, 0.7)
      // テキスト本文のフェードイン
      .from(textParagraph, { duration: 1.5, autoAlpha: 0, y: 30, ease: 'Power3.easeOut' }, 0.9)
      // // ２枚の画像のフェードイン
      // .from('._yearCurrentSecondAnimationImage', { duration: 8, autoAlpha: 0, y: 30 }, 9 * speed)
      // 円シェイプのフェードアウト
      .to(circleElement1, { duration: this.circleFadeOutSpeed, autoAlpha: this.circleOpacity, ease: 'Power3.easeOut' }, 12 * speed)
      .to(circleElement2, { duration: this.circleFadeOutSpeed, autoAlpha: this.circleOpacity, ease: 'Power3.easeOut' }, 12 * speed)
      .to(circleElement3, { duration: this.circleFadeOutSpeed, autoAlpha: this.circleOpacity, ease: 'Power3.easeOut' }, 12 * speed)
    } else
    {
      _CurrentTl
      .to(overlay, {duration: 5, opacity: 0.3, ease: 'Power3.easeOut'}, 0)
      // 年代フェードイン
      .from(titleElement, { duration: 1, autoAlpha: 0, y: 30, ease: 'Power3.easeOut' }, 0)
      // 年代フェードアウト
      // .to(titleElement, { duration: 2, autoAlpha: this.yearOpacity, ease: 'Power1.easeOut' }, 2.5 * speed)
      // 年代小フェードイン
      // .from('._subYearCurrent', { duration: 1.5, autoAlpha: 0, ease: 'Power3.easeOut'}, 5.6 * speed)
      // 円シェイプのフェードイン
      .from(circleElement1, { duration: this.circleFadeInSpeed, autoAlpha: 0, ease: 'Power3.easeOut' }, 4 * speed)
      .from(circleElement2, { duration: this.circleFadeInSpeed, autoAlpha: 0, ease: 'Power3.easeOut' }, 4 * speed)
      .from(circleElement3, { duration: this.circleFadeInSpeed, autoAlpha: 0, ease: 'Power3.easeOut' }, 4 * speed)
      // 円シェイプが動く
      .to(circleElement1, { duration: this.circleMoveSpeed / 1.5, xPercent: -120 / 8, yPercent: 62 / 32 * - 1, ease: 'Power2.easeOut' }, 9 * speed + 0.3)
      .to(circleElement2, { duration: this.circleMoveSpeed / 1.5, xPercent: 211 / 8, yPercent: -89 / 8 * 1.2, ease: 'Power2.easeOut' }, 9 * speed + 0.3)
      .to(circleElement3, { duration: this.circleMoveSpeed / 1.5, xPercent: 144 / 16, yPercent: 16 / 10 *  4.5, ease: 'Power2.easeOut' }, 9 * speed + 0.3)
      // テキストタイトルのフェードイン
      .from(textTitle, { duration: 1.2, autoAlpha: 0, y: 30, ease: 'Power1.easeOut' }, 0.7)
      // テキスト本文のフェードイン
      .from(textParagraph, { duration: 1.5, autoAlpha: 0, y: 30, ease: 'Power3.easeOut' }, 0.9)
      // // ２枚の画像のフェードイン
      // .from('._yearCurrentSecondAnimationImage', { duration: 8, autoAlpha: 0, y: 30 }, 9 * speed)
      // 円シェイプのフェードアウト
      .to(circleElement1, { duration: this.circleFadeOutSpeed * 1.5, autoAlpha: this.circleOpacity / 2, ease: 'Power2.easeOut' }, 12 * speed + 0.2)
      .to(circleElement2, { duration: this.circleFadeOutSpeed * 1.5, autoAlpha: this.circleOpacity / 2, ease: 'Power2.easeOut' }, 12 * speed + 0.2)
      .to(circleElement3, { duration: this.circleFadeOutSpeed * 1.5, autoAlpha: this.circleOpacity / 2, ease: 'Power2.easeOut' }, 12 * speed + 0.2)
    }
    
  }

  setScrollTriggerToBottomMessage(scroller)
  {
    const speed = this.animationSpeed
    const _BottomTl = gsap.timeline(
      {
        scrollTrigger:
        {
          trigger: "._yearCurrentSecond",
          scroller: scroller,
          start: "top center+=35%",
          end: "bottom top",
          toggleActions: "play none none none",
          pin: false,
        }
      }
    )

    _BottomTl.from('._bottomMessage', { duration: 1.2, autoAlpha: 0, y: 30, ease: 'Power1.easeOut'})
  }
}